// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"802ec4f2","977":"463df7a9"}[chunkId] + ".chunk.js";
};